import { ChannelGetMessagesStats, ChannelGetMessagesStatsResponse } from "../../proto/ChannelGetMessagesStats_pb";
import { RoomMessageStatus } from "../../proto/Global_pb";
import store from "../../store";
import { editRoomMessage, markAsReadMessages } from "../../store/messages/actions";
import { editRoom } from "../../store/rooms/actions";
import BaseHandler from "../BaseHandler";
import { seenChannel, seenMessage } from "../../libs/services";

export default class HandleChannelGetMessagesStatsResponse extends BaseHandler<ChannelGetMessagesStatsResponse, ChannelGetMessagesStats> {
  handle() {
    const channelGetMessagesStatsRequest = this.request?.toObject();
    const channelGetMessagesStatsResponse = this.response.toObject();

    if (channelGetMessagesStatsRequest !== undefined) {
      seenChannel(channelGetMessagesStatsRequest.roomId);
      channelGetMessagesStatsResponse.statsList?.forEach((stat) => {
        seenMessage(channelGetMessagesStatsRequest.roomId, stat.messageId);
        /* TODO: update channel properties
                          viewsLabel
                          thumbsUpLabel
                          thumbsDownLabel
                        */
      });
    }
  }
}
